<template>
  <div class="schedule container is-fluid">
    <div class="schedule-header-box">
      <ScheduleHeader
        :currentDate="currentDateWithFormat"
        :stats="ChangeOfFlightCounts"
      />
      <ScheduleActions
        :date="datepickerDate"
        :highlighted="highlighted"
        :disabledDays="disabledDays"
        :customFormatter="customFormatter"
        :isLoading="isLoading"
        :isDisabled = "isDisabled"
        :onDateOpened="openDateCalendar"
        :onDateClosed="TrygetScheduleFlightsfromDatepicker"
        @update:date="(val) => (datepickerDate = val)"
        @refresh="TrygetScheduleFlights"
      >
        <div
          class="control has-icons-left"
          :class="{ 'has-icons-right': isFiltering }"
        >
          <input
            class="box-info-search input"
            type="text"
            v-model="searchText"
            placeholder="Filter in table"
            @input="onSearchInput"
            :disabled="isFiltering"
          />

          <span class="icon is-left">
            <font-awesome-icon icon="search" />
          </span>
          <span v-if="isFiltering" class="icon is-right">
            <font-awesome-icon icon="circle-notch" spin />
          </span>
        </div>
      </ScheduleActions>
    </div>

    <div
      v-if="filteredFlights !== null && !isFiltering"
      class="schedule-flight-count-box"
    >
      <span class="count-text">
        Showing <strong>{{ displayedFlightsCount }}</strong> flight{{
          displayedFlightsCount !== 1 ? "s" : ""
        }}
      </span>
    </div>

    <div class="schedule-table-main">
      <table
        v-if="!isLoading"
        ref="tableBody"
        class="schedule-table table is-hoverable is-fullwidth is-narrow is-striped"
      >
        <thead>
          <tr>
            <th>Report</th>
            <th>Pre</th>
            <th>Post</th>
            <th>Flight Number</th>
            <th>Call Sign</th>
            <th>DEP</th>
            <th>ARR</th>
            <th></th>
            <th>Day</th>
            <th>STD</th>
            <th>STA</th>
            <th>CTOT</th>
            <th>Tail</th>
            <th>CPT</th>
            <th>F/O</th>
            <th>S/O</th>
            <th colspan="7"></th>
            <th v-if="user.permissions.includes('Schedule.Act')"></th>
          </tr>
        </thead>
        <!--:key="post.fKeyForZip"-->

        <tbody v-if="displayedFlights && displayedFlights.length">
          <tr
            v-for="post in displayedFlights"
            :key="post.fKeyForZip + '_' + post.leG_NO + '_' + post.btO_LVC + '_' + post.aL_LVC + '_' + post.notE_CNT"
            :style="
              CurrentTimeStartsubtracted < dtConverterToMinHour(post.sta) &&
              CurrentTimeFinishAdded > dtConverterToMinHour(post.std)
                ? { 'background-color': '#E9F0FA' }
                : ''
            "
            :class="[
              post.iS_DELETED == 1 && ShowDeletedFlights == true
                ? 'strikeout'
                : '',
              post.iS_DELETED == 1 && ShowDeletedFlights == false
                ? 'hideDeletedFlight'
                : '',
              post.iS_AIRCRAFT_USED == false && showRelatedAircrafts == true
                ? 'hideDeletedFlight'
                : '',
            ]"
          >
            <td>
              <div class="NotifyTooltip">
                <!--                                <div v-if="post.aL_LVC || post.btO_LVC" class="icon has-text-centered" @click="showReportModal(post.fKeyForZip,post.fKeyForNetline,post.std,post.btO_LVC,post.aL_LVC)">-->
                <!--                                <span><i class="fas fa-folder-open has-text-info is-size-4" cursor="pointer"></i></span>        -->
                <!--                                </div>                                                                                  -->

                <!--                                <div @click="showReportModalNewGen(post.fKeyForZip,post.fKeyForNetline,post.std,post.leG_NO,post)" class="icon has-text-centered">                          -->
                <!--                                    <span><i class="fas fa-folder-plus has-text-warning is-size-4"  cursor="pointer"></i></span>                                                            -->
                <!--                                </div>                                                                                                                                                      -->

                <div
                  v-if="post.btO_SignedBy !== ''"
                  @click="
                    showReportModalNewGen(
                      post.fKeyForZip,
                      post.fKeyForNetline,
                      post.std,
                      post.leG_NO,
                      post,
                      post
                    )
                  "
                  class="icon has-text-centered"
                >
                  <span
                    ><i
                      class="fas fa-folder-plus is-size-4"
                      cursor="pointer"
                      :style="{ color: StatuColorArray[1] }"
                    ></i
                  ></span>
                </div>

                <div v-else class="icon has-text-centered">
                  <span
                    ><i
                      class="fas fa-folder-minus is-size-4"
                      cursor="pointer"
                      :style="{ color: StatuColorArray[2] }"
                    ></i
                  ></span>
                </div>
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                <div v-if="post.btO_LVC">
                  <span class="icon is-info">
                    <i
                      class="fas fa-check"
                      :style="{ color: StatuColorArray[1] }"
                    ></i
                  ></span>
                </div>
                <div v-else>
                  <span class="icon is-danger"
                    ><i
                      class="fas fa-times"
                      :style="{ color: StatuColorArray[2] }"
                    ></i
                  ></span>
                </div>
                <span class="NotifyTooltipText">
                  Before Take Off Info <br />
                  Who Signed: {{ post.btO_SignedBy }}<br />
                  Ipad Device UID: <br />{{ post.lasT_IPADDEVICE_UID }}<br />
                  Ipad When Signed: {{ post.lasT_LVC.toString() }}<br />
                  Pre When Signed : {{ post.btO_LVC.toString() }}
                </span>
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                <div v-if="post.aL_LVC">
                  <span class="icon is-info"
                    ><i
                      class="fas fa-check"
                      :style="{ color: StatuColorArray[1] }"
                    ></i
                  ></span>
                </div>
                <div v-else>
                  <span class="icon is-danger"
                    ><i
                      class="fas fa-times"
                      :style="{ color: StatuColorArray[2] }"
                    ></i
                  ></span>
                </div>
                <span class="NotifyTooltipText">
                  After Landing Info<br />
                  Who Signed:{{ post.aL_SignedBy }}<br />
                  Ipad Device UID: <br />{{ post.lasT_IPADDEVICE_UID }}<br />
                  Ipad When Signed: {{ post.lasT_LVC.toString() }}<br />
                  Post When Signed: {{ post.aL_LVC.toString() }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip flight-number">
                {{ post.carrier }}{{ post.fnO_CORRECTED }}{{ post.suffix }}

                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[1] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[1] }}</span
                >
              </div>
            </td>

            <td class="NotifyTooltip call-sign">
              {{ post.callsign }}
            </td>

            <td>
              <div class="NotifyTooltip">
                {{ post.adep }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[3] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[3] }}</span
                >
              </div>
            </td>

            <td>
              <div v-if="post.diV_ARR" class="NotifyTooltip">
                <del>{{ post.aarr }}</del
                ><b>{{ "/" + post.diV_ARR }}</b>
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[3] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[3] }}</span
                >
              </div>
              <div v-if="!post.diV_ARR" class="NotifyTooltip">
                {{ post.aarr }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[3] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[3] }}</span
                >
              </div>
            </td>

            <td v-if="post.diS_TYPE != 'N'">
              {{
                post.diS_TYPE == "D"
                  ? "DIV"
                  : post.diS_TYPE == "R"
                  ? "RR"
                  : post.diS_TYPE == "F"
                  ? "FR"
                  : ""
              }}
            </td>
            <td v-else-if="post.diS_TYPE == 'N'"></td>

            <td>
              <div class="NotifyTooltip">
                {{ post.std | formatDateOnlyMonthDate }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[2] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[2] }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                {{ post.std | formatDateNumericWithHour }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[4] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[4] }}<br />
                  etd : {{ post.atd | longFormatDateFromString }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                {{ post.sta | formatDateNumericWithHour }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[5] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[5] }}<br />
                  eta : {{ post.ata | longFormatDateFromString }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip" v-if="post.ctot">
                <span
                  class="tag is-rounded"
                  :style="
                    post.tlc
                      ? {
                          backgroundColor: '#10B98126',
                          color: '#047857',
                          border: '1px solid #10B98133',
                          fontWeight: '600',
                          padding: '6px 12px',
                        }
                      : {
                          backgroundColor:
                            SyncStatColorArray[
                              isUnderTwoHours(post.std, post.eobt)
                            ].background,
                          color:
                            SyncStatColorArray[
                              isUnderTwoHours(post.std, post.eobt)
                            ].text,
                          border:
                            '1px solid ' +
                            SyncStatColorArray[
                              isUnderTwoHours(post.std, post.eobt)
                            ].border,
                          fontWeight: '600',
                          padding: '6px 12px',
                        }
                  "
                >
                  {{ showOnlyHourAndMinute(post.ctot) }}
                </span>
                <span v-if="post.tlc" class="NotifyTooltipText"
                  >TLC:{{ post.tlc }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                {{ post.acreg }}
                <span class="NotifyTooltipText"
                  >Prev1 : {{ post.preV_VALUE1.split("|")[0] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[0] }}</span
                >
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                <span
                  class="tag is-rounded"
                  :style="{
                    backgroundColor:
                      SyncStatColorArray[post.staT_MIN1].background,
                    color: SyncStatColorArray[post.staT_MIN1].text,
                    border:
                      '1px solid ' + SyncStatColorArray[post.staT_MIN1].border,
                    fontWeight: '600',
                    padding: '6px 12px',
                  }"
                >
                  {{ post.cP1 }}
                </span>
                            <span class="NotifyTooltipText">
                              <span>Prev1 : {{ post.preV_VALUE1.split("|")[8] }} Prev2 :{{ post.preV_VALUE2.split("|")[8] }} <br/></span>
                              <span>TLC : {{post.tlC1}} <br/> DEVICE UUID :<br/>{{post.devicE_UUID1}} <br/></span>
                              
                              
                                    <nav class="level" style="margin-bottom: 0px;">
                                      <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT1 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT1.substring(1,2)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">N</p>
                                        </div>
                                      </div>
                                      <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT1 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT1.substring(3,4)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">J</p>
                                        </div>
                                      </div>
                                      <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT1 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT1.substring(5,6)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">W</p>
                                        </div>
                                      </div>
                                      <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT1 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT1.substring(7,8)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">A</p>
                                        </div>
                                      </div>
                                    </nav>

                                    <div>
                                              Last OCC DT<span>: </span>{{post.stattexT1.substring(8,22)}}<br/>
                                              Last Ipad DT:{{post.stattexT1.substring(23,37)}} <br/>
                                              {{post.stattexT1}}
                                    </div>

                            </span>
              </div>
            </td>

            <td>
              <div class="NotifyTooltip">
                <span
                  class="tag is-rounded"
                  :style="{
                    backgroundColor:
                      SyncStatColorArray[post.staT_MIN2].background,
                    color: SyncStatColorArray[post.staT_MIN2].text,
                    border:
                      '1px solid ' + SyncStatColorArray[post.staT_MIN2].border,
                    fontWeight: '600',
                    padding: '6px 12px',
                  }"
                >
                  {{ post.cP2 }}
                </span>
              

                    <span class="NotifyTooltipText">
                      <span>Prev1 : {{ post.preV_VALUE1.split("|")[8] }} Prev2 :  {{ post.preV_VALUE2.split("|")[8] }} <br/></span>
                
                      <span>TLC : {{post.tlC2}} <br/> DEVICE UUID : <br/>{{post.devicE_UUID2}} <br/></span>      
                                <nav class="level" style="margin-bottom: 0px;">
                                  <div class="level-item has-text-centered">

                                    <div :style="[post.stattexT2 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT2.substring(1,2)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                          <p class="heading pilotStatus">N</p>
                                    </div>
                                  </div>
                                  <div class="level-item has-text-centered">
                                    <div :style="[post.stattexT2 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT2.substring(3,4)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                          <p class="heading pilotStatus">J</p>
                                    </div>
                                  </div>
                                  <div class="level-item has-text-centered">
                                    <div :style="[post.stattexT2 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT2.substring(5,6)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                          <p class="heading pilotStatus">W</p>
                                    </div>
                                  </div>
                                  <div class="level-item has-text-centered">
                                    <div :style="[post.stattexT2 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT2.substring(7,8)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                          <p class="heading pilotStatus">A</p>
                                    </div>
                                  </div>
                                </nav>
                                <div>
                                    Last OCC DT<span>: </span>{{post.stattexT2.substring(8,22)}}<br/>
                                    Last Ipad DT:{{post.stattexT2.substring(23,37)}} <br/>
                                    {{post.stattextT2}}
                                </div>
                            </span>
                
              </div>
            </td>

            <td>
              <div class="NotifyTooltip" v-if="post.cP3">
                <span
                  class="tag is-rounded"
                  :style="{
                    backgroundColor:
                      SyncStatColorArray[post.staT_MIN3].background,
                    color: SyncStatColorArray[post.staT_MIN3].text,
                    border:
                      '1px solid ' + SyncStatColorArray[post.staT_MIN3].border,
                    fontWeight: '600',
                    padding: '6px 12px',
                  }"
                >
                  {{ post.cP3 }}
                </span>
                    <span class="NotifyTooltipText">
                      <span>Prev1 : {{ post.preV_VALUE1.split("|")[8] }} Prev2 :
                  {{ post.preV_VALUE2.split("|")[8] }} <br/> </span>
                      <span>TLC : {{post.tlC3}} <br/> DEVICE UUID :<br/> {{post.devicE_UUID3}} <br/></span>    
                                    <nav class="level" style="margin-bottom: 0px;">
                                      <div class="level-item has-text-centered">

                                            <div :style="[post.stattexT3 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT3.substring(1,2)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                                <p class="heading pilotStatus">N</p>
                                            </div>
                                        </div>
                                        <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT3 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT3.substring(3,4)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">J</p>
                                        </div>
                                      </div>
                                        <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT3 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT3.substring(5,6)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">W</p>
                                        </div>
                                      </div>
                                        <div class="level-item has-text-centered">
                                        <div :style="[post.stattexT3 != '' ? {'backgroundColor' : SyncStatColorPilotArray[post.stattexT3.substring(7,8)]} : {'backgroundColor' : SyncStatColorPilotArray[0]}]">
                                              <p class="heading pilotStatus">A</p>
                                        </div>
                                      </div>
                                    </nav>
                                    <div>
                                        Last OCC DT<span>: </span>{{post.stattexT3.substring(8,22)}}<br/>
                                        Last Ipad DT:{{post.stattexT3.substring(23,37)}} <br/>
                                        {{post.stattexT3}}
                                    </div>
                      </span>
              </div>
            </td>

            <td class="attachment-cell">
              <div
              v-if="!(isRequestPending && loadingButton === 'attachment' && loadingRowId === post.fKeyForZip)"
                class="attachment-button"
                @click="
                  showAttachmentUploadModal(
                    post.fKeyForZip,
                    post.fKeyForNetline,
                    post.std,
                    post
                  )
                "
                title="Go to Attachment"
                :style="{
                  backgroundColor:
                    post.attachmentCount === 0 ? '#888888' : '#10B981',
                }"
              >
                <font-awesome-icon icon="paperclip" class="attachment-icon" />
                <span class="attachment-count">{{ post.attachmentCount }}</span>
              </div>
              <div v-else class="attachment-button" :style="{
                  backgroundColor:
                    post.attachmentCount === 0 ? '#888888' : '#10B981',
                }">
                <font-awesome-icon icon="circle-notch" spin class="attachment-icon"/>
               <span class="attachment-count">{{ post.attachmentCount }}</span>
              </div>
            </td>

            <td class="attachment-cell">
              <font-awesome-icon
              v-if="!(isRequestPending && loadingButton === 'ofp' && loadingRowId === post.fKeyForZip)"
                icon="route"
                size="lg"
                :color="StatuColorArray[post.flightRelease]"
                @click="
                  showAttachmentReleaseModal(
                    post.fKeyForNetline,
                    post.fKeyForZip,
                    post.std,
                    post.jlvt,
                    post.flightRelease,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Ofp.Pdf"
              />
              <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
            />
            </td>

            <!-- BU kısımda json objesi (UsedAirportItem) üzerinden data çekilecektir. -->
            <td class="attachment-cell">
              <font-awesome-icon
              v-if="!(isRequestPending && loadingButton === 'weathertext' && loadingRowId === post.fKeyForZip)"
                icon="fan"
                size="lg"
                :color="StatuColorArray[post.weatherWeb]"
                @click="
                  showWeatherTextModal(
                    post.fKeyForZip,
                    post.std,
                    post.wlvt,
                    post.weatherWeb,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Weather Text"
              />

              <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
            />
            </td>

            <td class="attachment-cell">
              <font-awesome-icon
               v-if="!(isRequestPending && loadingButton === 'notam' && loadingRowId === post.fKeyForZip)"
                icon="arrow-up"
                size="lg"
                :color="StatuColorArray[post.notamWeb]"
                @click="
                  showNotamModal(
                    post.fKeyForNetline,
                    post.fKeyForZip,
                    post.std,
                    post.wlvt,
                    post.notamWeb,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Notam"
              />

               <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
            />
            </td>
            <!--                        ArrowAltCircleLeft-->
            <td class="attachment-cell">
              <font-awesome-icon
              v-if="!(isRequestPending && loadingButton === 'notamfir' && loadingRowId === post.fKeyForZip)"
                icon="arrow-alt-circle-up"
                size="lg"
                :color="StatuColorArray[post.notamWeb]"
                @click="
                  showNotamFIRModal(
                    post.fKeyForNetline,
                    post.fKeyForZip,
                    post.std,
                    post.wlvt,
                    post.notamWeb,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Notam FIR"
              />

              <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
              />
            </td>

            <td class="attachment-cell">
              <font-awesome-icon
               v-if="!(isRequestPending && loadingButton === 'weatherchart' && loadingRowId === post.fKeyForZip)"
                icon="cloud"
                size="lg"
                :color="StatuColorArray[post.weather]"
                @click="
                  showWeatherChartModal(
                    post.fKeyForNetline,
                    post.fKeyForZip,
                    post.std,
                    post.wlvt,
                    post.weather,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Weather Charts"
              />

              <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
              />
            </td>

            <td class="attachment-cell">
              <!--StatuColorArray[post.raimPrediction]-->
              <font-awesome-icon
                v-if="!(isRequestPending && loadingButton === 'raim' && loadingRowId === post.fKeyForZip)"
                icon="map"
                size="lg"
                :color="StatuColorArray[post.raimPrediction]"
                @click="
                  showRaimPredictionModal(
                    post.fKeyForNetline,
                    post.fKeyForZip,
                    post.std,
                    post.wlvt,
                    post.raimPrediction,
                    post.flightArchiveStat,
                    post
                  )
                "
                style="cursor: pointer"
                title="Go to Raim Prediction"
              />

              <font-awesome-icon
                v-else
                icon="circle-notch"
                spin
                color="#10B981"
                style="cursor: not-allowed"
              />
            </td>

            <!--                            Manuel Update Flight işltemi geçici süreliğine kaldırıldı.                                      -->
            <!--                        <td v-if="user.permissions.includes('Schedule.Act')">&lt;!&ndash;  post.fKey1 fKeyForZip   &ndash;&gt;-->
            <!--                            <font-awesome-icon icon="edit" size="lg"-->
            <!--                                               @click=" goToEditFlight(post.fKeyForNetline,post.leG_NO)"-->
            <!--                                               :color="!post.manuelUpdate ? '#888888' : '#3298dc'"-->
            <!--                                               style="cursor: pointer"-->
            <!--                                               title="Go to Edit Flight"/>-->
            <!--                        </td>-->

            <!-- en sağdaki not kısmı -->
            <td style="max-width: 110px; width: 110px" class="NotifyTooltip">
              <div class="notify-container">
                <div
                  class="notes-container"
                  @click="
                    OpenFlightNoteModal(
                      post.fKeyForZip,
                      post.fKeyForNetline,
                      post.leG_NO,
                      post
                    )
                  "
                >
                  <font-awesome-icon
                    :icon="['far', 'comment-alt']"
                    :class="post.notE_CNT > 0 ? 'has-note' : 'no-note icon-color'"  
                    :style="{ filter: 'drop-shadow(0 0 0.5px currentColor)'  }"
                  />
                  <span v-if="post.notE_CNT > 0" class="note-count has-note">
                  </span>
                </div>

                <div
                  class="notify-btn"
                  @click="
                    OpenFlightNotifyModal(
                      post.fKeyForZip,
                      post.fKeyForNetline,
                      post.leG_NO,
                      post
                    )
                  "
                >
                  <font-awesome-icon icon="history" class="icon-color" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <loading-button />
      </div>
    </div>

    <article id="launch-modal">
      <div
        class="modal is-large"
        v-bind:class="{ 'is-active': isActiveFileUpload }"
      >
        <div @click="trycloseUploadModal" class="modal-background"></div>
        <div
          class="fileUploadModal modal-content animate__animated animate__zoomIn animate__faster"
          style="width: 90%; height: 80%"
        >
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{ headerFlightText }} - Additional Documents</h2>
            </div>
            <button class="close-btn"  @click="trycloseUploadModal">
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

          <section class="modal-card-body is-large">
            <div
              v-if="changeFlightListId.includes(activeFKey)"
              v-bind:class="{
                'notification is-warning model-row-transition':
                  changeFlightListId.includes(activeFKey),
              }"
            >
              <p>
                There are changes in the flight, please close the screen and
                check the flight again
                <span class="icon">
                  <i class="fas fa-exclamation has-text-danger"></i>
                </span>
              </p>
            </div>
            <transition name="fade" mode="out-in">
              <tabs animation="slide" :only-fade="false">
                <tab-pane label="Active Attachments">
                  <div v-if="openShowFileCount != 0" class="document-container">
                    <div class="table-wrapper-scroll">
                      <table
                      class="upload-modal-table table is-fullwidth is-bordered"
                    >
                      <thead>
                        <tr>
                          <th title="Real Name" class="sticky-column">Name</th>
                          <th>Attachment Type</th>
                          <th>Description</th>
                          <th>Size</th>
                          <th>Uploaded By</th>
                          <th>Uploaded On</th>
                          <th>Operations</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="attachment in attachmentsFlight"
                          :key="attachment.id"
                        >
                          <td
                          class="sticky-column"
                            @click="
                              showSelectedAdditionalDocumentVue(
                                attachment.id,
                                activeStd
                              )
                            "
                            :title="attachment.realName"
                          >
                          <div class="document-name">
                            <font-awesome-icon
                              icon="file-alt"
                              size="lg"
                              color="#3273dc"
                              style="cursor: pointer"
                              title="Show Attachment"
                            />
                            <span class="document-name-text">
                              {{ attachment.realName }}
                            </span>
                            <!-- @click="showSelectedAdditionalDocument(attachment.id,activeStd)" -->
                          </div>
                          </td>
                          <td>
                            {{
                              attachmentTypes.find(
                                (x) => x.value == attachment.attachmentTypeId
                              ).text
                            }}
                          </td>
                          <td>{{ attachment.description }}</td>
                          <td
                            v-if="
                              attachment.fileSize == null ||
                              attachment.fileSize == ''
                            "
                          >
                            No Record
                          </td>
                          <td v-else>{{ attachment.fileSize }} KB</td>
                          <td>{{ attachment.uploadedBy }}</td>
                          <td>
                            {{ attachment.modifiedAt | longFormatFromDT }}
                          </td>
                          <td
                            v-show="
                              user.permissions.includes(
                                'Schedule.AttachmentAdd'
                              )
                            "
                          >
                            <font-awesome-icon
                              icon="trash-alt"
                              size="lg"
                              @click="
                                DeleteOptions(
                                  attachment.id,
                                  attachment.lastKeyForNetline,
                                  attachment.realName,
                                  attachment.attachmentTypeId,
                                  attachment.uploadedBy
                                )
                              "
                              color="#f14668"
                              style="cursor: pointer"
                              title="Delete Attachment"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  </div>
                  <div class="file-upload-section">
                      <h1 class="title is-size-5">UPLOAD FLIGHT FILE</h1>
                      <file-pond
                        name="file"
                        id="FilePoundUpload"
                        ref="pond"
                        :files="file"
                        :server="fileUploadLocalServer"
                        :instant-upload="false"
                        :drop-on-page="true"
                        :allow-multiple="true"
                      />
                      <small class="text-muted"
                        >Drag &amp; drop feature work on whole page.</small
                      ><br />
                      <small class="text-muted"
                        >Continue the file upload process after the other one is
                        finished.</small
                      >
                    </div>
                  <!-- mesaj ve işlem karşılığı spden dönmektedir. <div v-show="attachmentIsTimePassedCheck==false && user.permissions.includes('Schedule.AttachmentAdd')"> -->
                  <div
                    v-show="user.permissions.includes('Schedule.AttachmentAdd')"
                  >
                    <div v-if="user.isAttachmentMaster" style="margin: 20px">
                      <div style="margin: 10px">
                        <p>Set Create Date time of file to upload :</p>
                        <input
                          type="datetime-local"
                          id="CreatedDt_"
                          class="input is-primary"
                          style="max-width: 250px"
                          name="CreatedDt"
                          v-model="AttachmentMasterModel.CreateDt"
                        />
                      </div>

                      <div style="margin: 10px">
                        <p>Set Modify date time of file to upload :</p>
                        <input
                          type="datetime-local"
                          id="ModifyDt_"
                          class="input is-primary"
                          style="max-width: 250px"
                          name="ModifyDt"
                          v-model="AttachmentMasterModel.ModifyDt"
                        />
                      </div>

                      <div style="margin: 10px">
                        <p>Select who upload user of file to upload:</p>
                        <div class="select">
                          <select
                            class="select is-medium"
                            v-model="selectedRole"
                            @change="roleChangedFilterUserList"
                          >
                            <option
                              v-for="role in rolelist"
                              :key="role.id"
                              :value="role"
                            >
                              {{ role.name }}
                            </option>
                          </select>
                        </div>
                        <div class="select">
                          <select
                            class="select is-medium"
                            v-model="selectedRelatedUserAttachmentUpl"
                          >
                            <option
                              v-for="user in filtereduserlist"
                              :key="user.id"
                              :value="user"
                            >
                              {{ user.fullName }} / {{ user.email }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                  </div>
                </tab-pane>
                <tab-pane label="Deleted Attachments">
                  <!-- v-show="attachmentIsTimePassedCheck==false" -->
                  <div class="">
                    <table class="table is-fullwidth is-bordered">
                      <thead>
                        <tr>
                          <th title="Real Name">Name</th>
                          <th>Attachment Type</th>
                          <th>Size</th>
                          <th>Deleted By</th>
                          <th>Deleted On</th>
                          <!--                                                <th>Operations</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="delattachment in deleteAttachments"
                          :key="delattachment.id"
                        >
                          <td>
                            <!--                                                                       @click="showSelectedAdditionalDocument(delattachment.id,activeStd)"-->
                            <font-awesome-icon
                              icon="file-alt"
                              size="lg"
                              color="#3273dc"
                              style="cursor: pointer"
                              title="Show Attachment"
                            />
                            {{ delattachment.realName }}
                          </td>
                          <td>
                            {{
                              attachmentTypes.find(
                                (x) => x.value == delattachment.attachmentTypeId
                              ).text
                            }}
                          </td>
                          <td
                            v-if="
                              delattachment.fileSize == null ||
                              delattachment.fileSize == ''
                            "
                          >
                            No Record
                          </td>
                          <td v-else>{{ delattachment.fileSize }} KB</td>
                          <td>{{ delattachment.uploadedBy }}</td>
                          <td>
                            {{ delattachment.modifiedAt | longFormatFromDT }}
                          </td>
                          <!--                                                <td v-show="user.permissions.includes('Schedule.AttachmentAdd')">-->
                          <!--                                                        <font-awesome-icon icon="undo-alt" size="lg"-->
                          <!--                                                                       @click="tryRevertAttachment(delattachment.id,delattachment.lastKeyForNetline,delattachment.realName,delattachment.attachmentTypeId,delattachment.uploadedBy)"-->
                          <!--                                                                       color="#3273dc"-->
                          <!--                                                                       style="cursor: pointer"-->
                          <!--                                                                       title="Revert Attachment"/>-->
                          <!--                                                </td>-->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </tab-pane>
              </tabs>
            </transition>
          </section>
          <footer class="modal-card-foot">
            <p v-if="message" class="model-row-transition notification">
              {{ message }}
            </p>
          </footer>
        </div>
      </div>
    </article>

    <div class="modal" v-bind:class="{ 'is-active': isActiveShowFile }">
      <div class="modal-background"></div>
      <div class="modal-content animate__animated animate__zoomIn animate__faster" >
        <div class="modal-header">
          <div class="header-content">     
            <div class="header-left">
              <p class="modal-card-title">Documents</p>
            </div>
              <button title="Close" class="close-btn"  @click="closeFileModal">
                  <font-awesome-icon icon="times" />
              </button>
          </div>
        </div>

        <div class="modal-card-body">
          <div
            v-if="isActiveShowFile && idOfPdf != null"
            class="columns is-gapless card-columns"
          >
            <div class="column is-3 file-sidebar">
                <div class="device-section"
                  v-for="attachmentFlight in attachmentsFlight"
                  :key="attachmentFlight.id"
                >            
                    <div
                     @click="idOfPdf = attachmentFlight.id"
                      class="attachment-file"
                      v-bind:class="{
                        'selected-attachment': idOfPdf == attachmentFlight.id,
                      }"
                    >
                          <div class="attachment-file-icon">
                            <span
                              v-if="
                                attachmentFlight.realName
                                  .toUpperCase()
                                  .includes('.PDF')
                              "
                            >
                              <img
                                src="../../assets/images/pdf.png"
                                height="24"
                                width="24"
                              />
                            </span>
                            <span v-else>
                              <img
                                src="../../assets/images/cameraColor .png"
                                height="24"
                                width="24"
                              />
                            </span>
  
                            <span class="file-realName">
                            {{ attachmentFlight.realName }}  
                            </span>
                          </div>
                        <div class="attachment-item-name">
                          <div class="file-item-top">
                            <span>
                              {{ attachmentFlight.uploadedBy }}
                              </span>


                           <span>{{ attachmentFlight.createdAt | shortFormatDateString
                          }}</span>
                          </div>
                          
                            <div class="file-item-bottom">
                              <font-awesome-icon icon="plus" />
                              <span>
                              {{
                                attachmentTypes.find(
                                  (x) =>
                                    x.value == attachmentFlight.attachmentTypeId
                                ).text
                              }}
                              </span>
                            </div>          
                        </div>
                      </div>
                    </div>
            </div>
            <div class="column is-9 preview-area">
              <div class="preview-container">
                <embed
                  type="application/pdf"
                  :src="
                    activePdfUrl +
                    idOfPdf +
                    '/' +
                    activeStd +
                    '/' +
                    activeArchiveId
                  "
                  width="100%"
                  height="100%"
                  alt="pdf"
                  background-color="0xFF525659"
                  top-toolbar-height="56"
                  full-frame=""
                  internalinstanceid="21"
                  title="CHROME"
                />
              </div>
            </div>
          </div>
          <div v-else class="notification is-warning is-light">
            No documents have been attached!
          </div>
        </div>
      </div>
    </div>

    <!--    Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal -->

    <!--
                  <div class="modal" v-bind:class="{'is-active':IsFileTypeAndWriteNoteModalIsActive}">
                      <div class="modal-background"></div>
                      <div class="modal-card" style="width:80%; height: 90%;">

                          <header class="modal-card-head">
                              <p class="modal-card-title">Type Attached File And Write Note For Upload</p>
                          </header>

                          <section class="modal-card-body">
                              <div class="box" style="background-color: #82a2c7; margin-top: 42px;">
                                  <div class="flex-form">
                                      <label style="margin-right: 15px;"><b>File Note:</b></label>
                                      <div class="field" style="flex-grow: 1;">
                                          <div class="control">
                                              <input id="FileNoteInput" v-model="fileNotebyUser" class="input input-hover" type="text" placeholder="You can write notes for file you are about to upload.">
                                          </div></div></div></div>
                              <div class="box" style="background-color: #82a2c7; margin-top: 12px;">
                                  <div class="flex-form"><label style="margin-right: 15px;"><b>Attachment Type</b></label>
                                      <div class="field" style="flex-grow: 1;">
                                          <div class="select">
                                              <select name="" id="SelectionOfAttachmentType">
                                                  <option value="0">Other</option>
                                                  <option value="9">WeatherChart</option>
                                                  <option value="13">Notam</option>
                                                  <option value="14">Weather</option>
                                                  <option value="15">Raim Prediction</option>
                                              </select>


                                              <select v-model="SelectedattachmentType" style = "width: 250px">
                                                  <option v-for="attType in FlightofattachmentTypesState" v-bind:key="attType.value" v-bind:value="attType.value">this.attType.text</option>
                                              </select>



                                              {text: 'Other', value:0, stat:2}, // her durumda kullanılır.
                                              {text: 'Weather Chart', value:9, stat:0},
                                              {text: 'Notam', value:13, stat:0},
                                              {text: 'Weather', value:14, stat:0},
                                              {text: 'Raim Prediction', value:15, stat:0}


                                          </div></div></div></div>

                                 <div class="">  <button  type="button" class="button is-info is-medium">Next</button></div>
                           </section>

                        </div>
                    </div>
          -->

    <!--    Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal  Attachment File Upload File Type and Write Note Modal -->

    <ShowAttachmentModal
      :isActiveAttachmentModal="isActiveAttachmentModal"
      :activeUrl="attachmentActiveUrl"
      :activeFKey="attachmentActiveFKey"
      :headerFlightText="headerFlightText"
      :attachmentType="attachmentActiveType"
      @closeAttachmentModal="closeAttachmentModal"
    />

    <EFBReportModal
      :activeUrl="attachmentActiveUrl"
      :activeFKey="attachmentActiveFKey"
      :headerFlightText = "headerFlightText"
      @closeEFBReportModal="closeEFBReportModal"
    />

    <html-rendering
      :isActiveHtmlModal="isActiveHtmlModal"
      :WRJsonData="S_WRjsonData"
      :headerFlightText = "headerFlightText"
      @closeHtmlModal="closeHtmlModal"
    />

    <Notam-JsonModal
      :isActiveNotamJsonModal="isActiveNotamJsonModal"
      :WRJsonData="S_WRjsonData"
      :S_WNReqJetP_Data="S_WNReqJetP_Data"
      :headerFlightText = "headerFlightText"
      @closeNotamJsonModal="closeNotamJsonModal"
    />

    <Notam-FIRJsonModal
      :isActiveNotamFIRJsonModal="isActiveNotamFIRJsonModal"
      :WRJsonData="S_WRjsonData"
      :S_WNReqJetP_Data="S_WNReqJetP_Data"
      :headerFlightText = "headerFlightText"
      @closeNotamFIRJsonModal="closeNotamFIRJsonModal"
    />

    <Weather-JsonModal
      :isActiveWeatherJsonModal="isActiveWeatherJsonModal"
      :WRJsonData="S_WRjsonData"
      :S_WNReqJetP_Data="S_WNReqJetP_Data"
      :headerFlightText = "headerFlightText"
      @closeWeatherJsonModal="closeWeatherJsonModal"
    />

    <FlightNoteModal
      :activeLegNo="flightNoteActiveLegNo"
      :headerFlightText="headerFlightText"
      @closeFlightNoteModal="closeFlightNoteModal"
    />

    <FlightNotifyModal
      :activeLegNo="flightNotifyActiveLegNo"
      :headerFlightText ="headerFlightText"
      @closeFlightNotifyModal="closeFlightNotifyModal"
    />
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
//import Datepicker from 'vue-bulma-datepicker';
// import Datepicker from "vuejs-datepicker";
import ScheduleService from "../../services/schedule.service";
import { TabPane, Tabs } from "vue-bulma-tabs";
import ShowAttachmentModal from "../../components/ui/ShowAttachmentModal";
import { loadingMixin } from "../../utils/mixins";
import LoadingButton from "../../components/ui/LoadingButton";
import HtmlRendering from "../../components/ui/HtmlRendering";
import NotamJsonModal from "../../components/ui/NotamJsonModal";
import NotamFIRJsonModal from "../../components/ui/NotamFIRShowJsonModal";
import WeatherJsonModal from "../../components/ui/WeatherJsonModal";
import FlightNoteModal from "../../components/ui/Schedule/FlightNoteModal.vue";
import EFBReportModal from "../../components/ui/EFBReportModal";
import ScheduleHeader from "../../components/ui/Schedule/ScheduleHeader.vue";

import * as moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import { right } from "core-js/internals/array-reduce";
import ScheduleActions from "../../components/ui/Schedule/ScheduleActions.vue";
import _ from "lodash";
import FlightNotifyModal from "../../components/ui/Schedule/FlightNotifyModal.vue";
import axios from "axios";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);
var currentDateWithFormat = new Date().toLocaleString();

export default {
  name: "schedule",
  mixins: [loadingMixin],

  data: function () {
    return {
      fKeyForZip: "",
      fKeyForNetline: "",
      std: "",
      post: "",
      infoModal: false,
      currentDateWithFormat,
      selectedDate: this.$route.params.date,
      datepickerDate: new Date(), //null,
      disabledDays: { from: new Date() }, // new Date(),//moment(new Date()).format('YYYY-MM-DD'),// new Date().getDate()+2, //null, // moment(new Date()).format('YYYY-MM-DD')
      calcAddday: new Date(),
      highlighted: { dates: [new Date(this.currentDateWithFormat)] },
      errors: [],
      showRelatedAircrafts: true,
      checkChanges: false,
      occVersionInfoByKFZ: null,
      NotamImportantList: [],
      searchText: "",
      headerFlightText : "",
      attachmentActiveType: "",
      // scheduleCancelToken : null,
      // checkChangesCancelToken: null,
      checkChangesInterval: null,
      isDisabled:false,
      filteredFlights: null,
      isFiltering: false,
      isRequestPending : false,
      loadingButton: null,
      loadingRowId:null,
      filesName: [],
      file: null,
      isActiveAttachmentModal: false,
      excelFlightList: [],
      attachmentActiveUrl: null,
      attachmentActiveFKey: null,
      attachmentIsTimePassedCheck: "",
      attachmentActiveKeyForNetline: null,
      selectedRelatedUserAttachmentUpl: "",
      selectedRole: "",
      filtereduserlist: [],
      message: null,
      fileNotebyUser: "TEST",
      SelectedattachmentType: 0,
      foundAttachmentId: 0,
      foundAttachmentALVT: 0,
      Attach_Upd_IsPopupShow: false,
      UpdateAttachment: null,
      IsTimeWrittenFlag: false,
      ShowDeletedFlights: false,
      AttachmentMasterModel: {
        related_User: null,
        CreateDt: null,
        ModifyDt: null,
      },
      // selectedRelatedUserAttachmentUpl: null,
      attachmentTypes: [
        { text: "Other", value: 0, stat: 0 },
        { text: "Weather Chart", value: 9, stat: 0 },
        { text: "Notam", value: 13, stat: 0 },
        { text: "Weather", value: 14, stat: 0 },
        { text: "Raim Prediction", value: 15, stat: 0 },
      ],
      SelectionAttachmentTypes: [],
      StatuColorArray: [
        "#888888",
        "#10B981",
        "#EF4444",
        "#EF4444",
        "#EF4444",
        "#F59E0B",
      ],
      SyncStatColorArray: [
        {
          background: "#888888",
          border: "#888888",
          text: "#fff",
        },
        {
          background: "#10B981",
          border: "#10B98133",
          text: "#fff",
        },
        {
          background: "#EF4444",
          border: "#EF444433",
          text: "#fff",
        },
        {
          background: "#ffc300",
          border: "#F59E0B33",
          text: "#fff",
        },
        {
          background: "#F59E0B",
          border: "#F59E0B33",
          text: "#fff",
        },
        {
          background: "#F59E0B",
          border: "#F59E0B33",
          text: "#fff",
        },
        {
          background: "#F1F5F9",
          border: "#CBD5E1",
          text: "#334155",
        },
      ],

                      SyncStatColorPilotArray :[
                    "#888888",
                    "#48c774",
                    "#f14668",
                    "#FDA50F",
                    "#FDA50F",
                    "#FDA50F",
                ],

      PilotGeneralSyncStat: [
        "fas fa-square has-text-danger",
        "fas fa-square has-text-success",
        "fas fa-square has-text-danger",
        "fas fa-square has-text-warning",
      ],

      StatuGeneralStats: [
        "window-close",
        "check-circle",
        "window-close",
        "window-close",
      ],

      htmlContent: "<p>Deneme</p>",
      WRJsonData: null,
      isActiveHtmlModal: false,
      isActiveWeatherJsonModal: false,
      isActiveNotamJsonModal: false,
      isActiveNotamFIRJsonModal: false,
      NotifyVisible: false,
      CurrentTime: 0,

      IsFileTypeAndWriteNoteModalIsActive: false,
      fileUploadLocalServer: {
        process: (
          fieldName,
          file,
          metadata,
          load,
          error,
          progress,
          abort,
          transfer,
          options
        ) => {
          (async () => {
            try {
              console.log("transfer");
              console.log(transfer);
              console.log("options");
              console.log(options);
              //this.IsFileTypeAndWriteNoteModalIsActive = true;

              var isTypeandNoteModalActive = true;
              //document.getElementsByClassName(".filepond--file-action-button.filepond--file-action-button").style.display = "none";

              this.DisplayElementsByClassName(
                "filepond--file-action-button",
                "none"
              );

              await this.$swal({
                title: "Type File and Note It. ",
                html:
                  '<section class="modal-card-body">\n' +
                  "<h3>You are about to upload " +
                  file.name +
                  " file.</h3>\n" +
                  '                        <div class="box" style="background-color: #82a2c7; margin-top: 42px;">\n' +
                  '                            <div class="flex-form">\n' +
                  '                                <label style="margin-right: 15px;"><b>File Note</b></label>\n' +
                  '                                <div class="field" style="flex-grow: 1;">\n' +
                  '                                    <div class="control">\n' +
                  '                                        <input id="FileNoteInput" v-model="fileNotebyUser" class="input input-hover" type="text" placeholder="You can write notes for file you are about to upload.">\n' +
                  "                                    </div></div></div></div>\n" +
                  '                        <div class="box" style="background-color: #82a2c7; margin-top: 12px;">\n' +
                  '                            <div class="flex-form"><label style="margin-right: 15px;"><b>Attachment Type</b></label>\n' +
                  '                                <div class="field" style="flex-grow: 1;">\n' +
                  '                                    <div class="select">\n' +
                  '                                        <select name="" id="SelectionOfAttachmentType">\n' +
                  '                                            <option value="0">Other</option>\n' +
                  '                                            <option value="9">WeatherChart</option>\n' +
                  '                                            <option value="13">Notam</option>\n' +
                  '                                            <option value="14">Weather</option>\n' +
                  '                                            <option value="15">Raim Prediction</option>\n' +
                  '                                        </select> <input hidden type="text" id="value">\n' +
                  "                                        <!--\n" +
                  "                                        {text: 'Other', value:0, stat:2}, // her durumda kullanılır.\n" +
                  "                                        {text: 'Weather Chart', value:9, stat:0},\n" +
                  "                                        {text: 'Notam', value:13, stat:0},\n" +
                  "                                        {text: 'Weather', value:14, stat:0},\n" +
                  "                                        {text: 'Raim Prediction', value:15, stat:0}\n" +
                  "                                        -->\n" +
                  "\n" +
                  "                                    </div></div></div></div>\n" +
                  "\n" +
                  "                     </section>",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#C5381A",
                confirmButtonColor: "#1874DA",
                confirmButtonText: "Next",
              }).then((response) => {
                if (response.value) {
                  var select = document.getElementById(
                    "SelectionOfAttachmentType"
                  );
                  var option = select.options[select.selectedIndex];

                  this.SelectedattachmentType = option.value;

                  this.fileNotebyUser =
                    document.getElementById("FileNoteInput").value;

                  // document.getElementById('text').value = option.text;
                  // bu kısımda selectoption bilgisinin çekilmesi gerekmeketedir.
                  // control amaçlı input bilgisininde test eedilmesi gerekiyor .
                  // yes no sorulu olması gerekmektedir.

                  console.log("response bekle " + response.value);
                } else {
                  isTypeandNoteModalActive = false;
                  // alert(file.id)
                  // console.log(file);
                  // console.log(this.$refs.pond);
                  //this.$refs.pond.removeFile(file);

                  return;
                }
              });

              if (isTypeandNoteModalActive == false) {
                this.DisplayElementsByClassName(
                  "filepond--file-action-button",
                  "block"
                );
                abort();
              }

              let updatedAttachmentwithStat = null;
              if (this.user.isAttachmentMaster != 1) {
                updatedAttachmentwithStat =
                  await ScheduleService.NeedReplaceForFileUpload(
                    this.activeFkeyForZip,
                    file.name,
                    this.SelectedattachmentType,
                    this.activeFKey
                  );
                console.log("need placement");
                console.log(updatedAttachmentwithStat);
                //updatedAttachmentwithStat =  JSON.parse(JSON.stringify(updatedAttachmentwithStat, null, 2));
              } else {
                updatedAttachmentwithStat =
                  await ScheduleService.NeedReplaceForFileUpload_SpecialFunc(
                    this.activeFkeyForZip,
                    file.name,
                    this.SelectedattachmentType,
                    this.activeFKey,
                    this.selectedRelatedUserAttachmentUpl,
                    this.AttachmentMasterModel.CreateDt,
                    this.AttachmentMasterModel.ModifyDt
                  );
                updatedAttachmentwithStat = JSON.parse(
                  JSON.stringify(updatedAttachmentwithStat, null, 2)
                );
                console.log("needplacement 2 ");
              }

              this.UpdateAttachment = updatedAttachmentwithStat.data;

              if (this.UpdateAttachment.upt_check_stat == 3) {
                //this.$refs.pond.removeFile();
                this.message = this.UpdateAttachment.upt_check_message;
                //this.$notify({title: "Warning", text: +this.UpdateAttachment.upt_check_stat+ " " +this.UpdateAttachment.upt_check_message , type: "warning"});
              }

              if (
                this.UpdateAttachment.upt_check_stat == 2 &&
                this.UpdateAttachment.attachmentTypeId != 0
              ) {
                this.foundAttachmentId = updatedAttachmentwithStat.data.id;
                this.foundAttachmentALVT = updatedAttachmentwithStat.data.alvt;
                let res = null;
                if (this.user.isAttachmentMaster != 1) {
                  res = await ScheduleService.setFileUpload(
                    file,
                    this.activeFKey,
                    this.fileNotebyUser,
                    this.SelectedattachmentType,
                    this.activeStd,
                    this.foundAttachmentId,
                    this.foundAttachmentALVT,
                    this.activeFkeyForZip
                  );
                } else {
                  res = await ScheduleService.setFileUpload_SpecialFunc(
                    file,
                    this.activeFKey,
                    this.fileNotebyUser,
                    this.SelectedattachmentType,
                    this.activeStd,
                    this.foundAttachmentId,
                    this.foundAttachmentALVT,
                    this.activeFkeyForZip,
                    this.selectedRelatedUserAttachmentUpl.fullName,
                    this.AttachmentMasterModel.CreateDt,
                    this.AttachmentMasterModel.ModifyDt
                  );
                }

                if (res.data.stat != 1) {
                  this.message = res.data.message;
                } else if (res.data.stat == 1) {
                  console.log(res);
                }

                //console.log(res);

                await this.$swal({
                  title: "",
                  html: this.UpdateAttachment.upt_check_message,
                  confirmButtonColor: "#1874DA",
                  confirmButtonText: "Ok.",
                }).then((response) => {
                  if (response.value) {
                    this.DisplayElementsByClassName(
                      "filepond--file-action-button",
                      "block"
                    );
                    load();

                    return;
                  }
                });
              } else if (
                this.UpdateAttachment.upt_check_stat == 1 &&
                this.UpdateAttachment.attachmentTypeId != 0
              ) {
                this.foundAttachmentId = 0;
                this.foundAttachmentALVT = 0;
                let res = null;
                if (this.user.isAttachmentMaster != 1) {
                  res = await ScheduleService.setFileUpload(
                    file,
                    this.activeFKey,
                    this.fileNotebyUser,
                    this.SelectedattachmentType,
                    this.activeStd,
                    this.foundAttachmentId,
                    this.foundAttachmentALVT,
                    this.activeFkeyForZip
                  );
                } else {
                  res = await ScheduleService.setFileUpload_SpecialFunc(
                    file,
                    this.activeFKey,
                    this.fileNotebyUser,
                    this.SelectedattachmentType,
                    this.activeStd,
                    this.foundAttachmentId,
                    this.foundAttachmentALVT,
                    this.activeFkeyForZip,
                    this.selectedRelatedUserAttachmentUpl.fullName,
                    this.AttachmentMasterModel.CreateDt,
                    this.AttachmentMasterModel.ModifyDt
                  );
                }
                if (res.data.stat != 1) {
                  this.message = res.data.message;
                  abort();
                } else if (res.data.stat == 1) {
                  load(res);
                }

                //await this.TrygetScheduleFlights();
                await this.getAttachmentByFlights(this.activeFKey);
                await this.$store.dispatch("schedule/getAttachmentByFlights");
                this.DisplayElementsByClassName(
                  "filepond--file-action-button",
                  "block"
                );
              }

              if (
                this.UpdateAttachment.upt_check_stat == 2 &&
                this.UpdateAttachment.attachmentTypeId == 0
              ) {
                this.foundAttachmentId = updatedAttachmentwithStat.data.id;
                this.foundAttachmentALVT = updatedAttachmentwithStat.data.alvt;

                await this.$swal({
                  title:
                    '<p style="text-align: left;font-size: 22px;">Do you want to update attachment?</p>',
                  html: this.UpdateAttachment.upt_check_message, // // buraya sp den dönen mesaj gelsin.
                  showCancelButton: true,
                  cancelButtonText: "Cancel",
                  cancelButtonColor: "#C5381A",
                  confirmButtonColor: "#1874DA",
                  confirmButtonText: "Replace",
                }).then(async (response) => {
                  if (response.value) {
                    let res = null;
                    if (this.user.isAttachmentMaster != 1) {
                      res = await ScheduleService.setFileUpload(
                        file,
                        this.activeFKey,
                        this.fileNotebyUser,
                        this.SelectedattachmentType,
                        this.activeStd,
                        this.foundAttachmentId,
                        this.foundAttachmentALVT,
                        this.activeFkeyForZip
                      );
                    } else {
                      res = await ScheduleService.setFileUpload_SpecialFunc(
                        file,
                        this.activeFKey,
                        this.fileNotebyUser,
                        this.SelectedattachmentType,
                        this.activeStd,
                        this.foundAttachmentId,
                        this.foundAttachmentALVT,
                        this.activeFkeyForZip,
                        this.selectedRelatedUserAttachmentUpl.fullName,
                        this.AttachmentMasterModel.CreateDt,
                        this.AttachmentMasterModel.ModifyDt
                      );
                    }

                    console.log(res);
                    //this.$refs.pond.removeFile();

                    this.getAttachmentByFlights(this.activeFKey);
                    this.$store.dispatch("schedule/getAttachmentByFlights");
                    this.DisplayElementsByClassName(
                      "filepond--file-action-button",
                      "block"
                    );
                    load();
                    //return;
                  } else {
                    this.DisplayElementsByClassName(
                      "filepond--file-action-button",
                      "block"
                    );
                    abort();

                    //this.$refs.pond.removeFile();
                    return;
                  }
                });
              } else if (
                this.UpdateAttachment.upt_check_stat == 1 &&
                this.UpdateAttachment.attachmentTypeId == 0
              ) {
                console.log("geldimi....");
                this.foundAttachmentId = 0;
                this.foundAttachmentALVT = 0;
                let res = null;
                console.log(this.user);
                if (this.user.isAttachmentMaster != 1) {
                  res = await ScheduleService.setFileUpload(
                    file,
                    this.activeFKey,
                    this.fileNotebyUser,
                    this.SelectedattachmentType,
                    this.activeStd,
                    this.foundAttachmentId,
                    this.foundAttachmentALVT,
                    this.activeFkeyForZip
                  );
                  //await new Promise(r => setTimeout(r, 10000));
                  console.log("setfileupload ");
                  console.log(res);
                }

                this.DisplayElementsByClassName(
                  "filepond--file-action-button",
                  "block"
                );
                abort();
                await this.getAttachmentByFlights(this.activeFKey);
                await this.getDeleteAttachments(this.activeFKey);
                await this.$store.dispatch("schedule/getAttachmentByFlights");

                ///Dosya yükleme esnasında hata veriyor. Aslında dosya yükleniyor... res boş geliyor.
                // if(res.data.stat != 1)
                // {
                //     this.message = res.data.message;
                //     this.DisplayElementsByClassName("filepond--file-action-button","block")
                //     abort();
                //     await this.getAttachmentByFlights(this.activeFKey);
                //     await this.getDeleteAttachments(this.activeFKey);
                //     await this.$store.dispatch("schedule/getAttachmentByFlights");
                // }
                // else if(res.data.stat == 1)
                // {
                //     this.DisplayElementsByClassName("filepond--file-action-button","block")
                //     load(res);
                //     await this.getAttachmentByFlights(this.activeFKey);
                //     await this.getDeleteAttachments(this.activeFKey);
                //     await this.$store.dispatch("schedule/getAttachmentByFlights");
                // }
              }

              //this.$refs.pond.removeFile();
              // await this.TrygetScheduleFlights();
              await this.getAttachmentByFlights(this.activeFKey);
              await this.getDeleteAttachments(this.activeFKey);
              await this.$store.dispatch("schedule/getAttachmentByFlights");
            } catch (e) {
              this.message = e.message;
            }

            this.DisplayElementsByClassName(
              "filepond--file-action-button",
              "block"
            );
          })();
        },
      },
      FlightCounts: {
        TotalFlights: 0,
        Completed: 0,
        InProgress: 0,
        Overdue: 0,
      },
      FlightNoteForm: {
        LEG_NO: 0,
        Message: "",
      },
      writtenFlightNote: "",
      flightNote: "",
      flightNoteActiveLegNo: null,
      flightNotifyActiveLegNo: null,
      isInputFunctionRunning: false,
      FlightNoteInput: "",
    };
  },

  components: {
    FilePond,
    Tabs,
    TabPane,
    ShowAttachmentModal,
    LoadingButton,
    HtmlRendering,
    NotamJsonModal,
    NotamFIRJsonModal,
    WeatherJsonModal,
    FlightNoteModal,
    EFBReportModal,
    ScheduleHeader,
    ScheduleActions,
    FlightNotifyModal,
  },

  methods: {
    right,
    ...mapActions("schedule", [
      "getScheduleFlights",
      "getScheduleChangeFlights",
      //"getDailyFlightSummary",
      "getSearchScheduleFlights",
      "showUploadModal",
      "showUploadModalV2",
      "closeUploadModal",
      "fileUploadxxx",
      "getAttachmentByFlights",
      //"deleteDocument",
      "deleteDocumentV2",
      "showDocumentFileModal",
      "closeFileModal",
      "updateIdOfPdf",
      "showSelectedAdditionalDocument",
      "getDeleteAttachments",
      "revertAttachment",
      "GetWRjson",
      "GetWeatherNotamRequestJetPData",
      "showFlightNoteModal",
      "showFlightNotifyModal",
      "closeFlightNoteModal",
      "closeFlightNotifyModal",
      "showEFBReportModal",
      "closeEFBReportModal",
      "GetEFBReportFiles",
      "GetFlightNotes",
      "ForceUpdateNetlineIntegrationModule",
      "clearScheduleFlights",
      "getAllUsers",
      "getAllRoles",
      //"AddFligtNote"
    ]),

    ...mapMutations("schedule", [
      "set_File_Change",
      "set_ActiveArchiveIdForAttachment",
    ]),
    showOnlyHourAndMinute(date) {
      return moment(date).format("HH:mm");
    },

    isUnderTwoHours(date, eobt) {
      const diffStd = moment.utc(date).diff(moment.utc(), "minutes");
      const diffEobt = moment.utc(eobt).diff(moment.utc(), "minutes");

      if (diffStd < 120) {
        if (diffEobt < 20) return 2;
        return 3;
      } else {
        return 6;
      }
    },

    async showSelectedAdditionalDocumentVue(attachmentid, activeSTD) {
      console.log("düştü");
      //  alert(attachmentid+'|||'+activeSTD)
      this.set_ActiveArchiveIdForAttachment(0);
      await this.showSelectedAdditionalDocument(attachmentid, activeSTD);
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    customFormatterWithHour(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss.SSS");
    },

    customFormatterHourMin(date) {
      return moment(date).format("HH:mm:ss");
    },

    getSyncStatColorArray(statText) {
      if (statText == "" || statText == null) {
        return "0";
      } else {
        statText;
      }
    },

    async getNotamImportantWordList() {
      var wordlist = await ScheduleService.GetNotamImportantList();
      this.NotamImportantList = wordlist;
      console.log("getNotamImportantWordList RUN");
    },

    ClickEventOfGetSchedule() {
      //console.log("ClickEventOfGetSchedule")
      const elem = this.$refs.TryGetScheduleFlightClick;
      elem.click();
      console.log("ClickEventOfGetSchedule RUN");
    },

    async GetScheduleFlightsRoutePush() {
      this.$router
        .push({ name: "Schedule", params: { date: this.SearchDate } })
        .catch(() => {});
    },

    startCheckChangesInterval() {
      this.stopCheckChangesInterval();
      this.checkChangesInterval = setInterval(async() => {
       try{
        if(this.checkChanges) {
          await this.getScheduleChangeFlights();         
        }
      }catch(error) {
          console.log(error)
        }
      }, 5000)
    },

    stopCheckChangesInterval() {
      if(this.checkChangesInterval) {
        clearInterval(this.checkChangesInterval);
        this.checkChangesInterval = null;
      }
    },

    async TrygetScheduleFlights() {
      this.isDisabled = true;
      this.showLoading();
      this.stopCheckChangesInterval();

      try {
        await this.getScheduleFlights();
        //this.InitTimeRow();
      } catch (e) {
        if (axios.isCancel(e)) {
          // this.hideLoading();
          return;
        }
      } finally {
        this.isDisabled = false;
        this.hideLoading();
        this.startCheckChangesInterval();
      }
    },

    openDateCalendar() {
      var t = Date.now();

      this.highlighted = { dates: [new Date(t)] };
    },

    async TrygetScheduleFlightsfromDatepicker() {
      this.showLoading();
      this.isDisabled = true
      this.stopCheckChangesInterval();

      // this.clearScheduleFlights();

      this.searchText = "";
      var t = Date.now();
      this.highlighted = { dates: [new Date(t)] };
      this.SearchDate = moment(this.datepickerDate).format("YYYY-MM-DD");
      this.$router
        .push({ name: "Schedule", params: { date: this.SearchDate } })
        .catch(() => {});

      try {
        await this.getScheduleFlights();
        //this.InitTimeRow();
        } catch (e) {
      if (axios.isCancel(e)) {
        this.hideLoading();
        return;
      }
      // Gerçek hata durumu
      console.error("Hata:", e);
    }  finally {
        this.isDisabled = false
        this.hideLoading();
        this.startCheckChangesInterval();
      }
    },

    // changeDay(direction) {
    //   this.datepickerDate = moment(this.datepickerDate)
    //     .add(direction, "days")
    //     .toDate();
    // },

    blockIfPending(event) {
      if(this.isRequestPending) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },

    goToFolderHistory(FKeyForZip, flight, generaL_STAT, FkeyForNetline, legno) {
      this.$router.push({
        name: "FlightFolderHistory",
        params: {
          id: FKeyForZip,
          kfnl: FkeyForNetline,
          legno: legno,
          flight: flight,
          SearchDate: this.SearchDate,
        },
      });
    },

    closeAttachmentModal() {
      this.isActiveAttachmentModal = false;
    },

    async ManipulateAttachmentCNT() {
      // active attachment a bağlı keyfornetline olur , fkeyforzip olur bunlara bak.
      this.flightList.find(
        (x) => x.fKeyForZip == this.activeFkeyForZip
      ).attachmentCount = this.attachmentsFlight.length;
    },

    closeHtmlModal() {
      this.isActiveHtmlModal = false;
    },

    closeNotamJsonModal() {
      this.isActiveWeatherJsonModal = false;
      this.isActiveNotamJsonModal = false;
      this.isActiveNotamFIRJsonModal = false;
    },

    closeNotamFIRJsonModal() {
      this.isActiveWeatherJsonModal = false;
      this.isActiveNotamJsonModal = false;
      this.isActiveNotamFIRJsonModal = false;
    },

    closeWeatherJsonModal() {
      this.isActiveWeatherJsonModal = false;
    },

    async OpenFlightNoteModal(fKeyForZip, fKeyForNetline, LegNo, post) {
      this.flightNoteActiveLegNo = LegNo;
      this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

      await this.showFlightNoteModal({
        FKeyForZip: fKeyForZip,
        FKeyForNetline: fKeyForNetline,
        LegNo: LegNo,
      });
      await this.GetFlightNotes(LegNo);
    },

    async OpenFlightNotifyModal(fKeyForZip, fKeyForNetline, LegNo, post) {
      try {
        this.flightNotifyActiveLegNo = LegNo;
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        await this.showFlightNotifyModal({
          FKeyForZip: fKeyForZip,
          FKeyForNetline: fKeyForNetline,
          LegNo: LegNo,
        });
        await this.GetFlightNotes();
        try {
          const noteT = this.FlightNoteList?.find((x) => x.ntype === "T");
          console.log(noteT);
          this.FlightNotifyDetails = noteT?.message
            ? JSON.parse(noteT.message)
            : [];
        } catch (e) {
          console.error("Parse error:", e);
          this.FlightNotifyDetails = [];
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },

    hideFlightNoteModal() {
      this.closeFlightNoteModal();
    },
    hideFlightNotifyModal() {
      this.closeFlightNotifyModal();
    },

    async showAttachmentUploadModal(fKeyForZip, fKeyForNetline, std, post) {
      this.isRequestPending = true;
      this.loadingButton = 'attachment';
      this.loadingRowId = fKeyForZip;

      try{
        this.fKeyForZip = fKeyForZip;
        this.FkeyForNetline = fKeyForNetline;
        this.std = std;
        this.post = post;
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        console.log("geldi");
        this.set_ActiveArchiveIdForAttachment(post.flightArchiveStat);
        this.attachmentIsTimePassedCheck = post.istimepassed;
        await this.showUploadModalV2({
          FKeyForZip: fKeyForZip,
          FKeyForNetline: fKeyForNetline,
          Std: std,
          postflight: post,
        });
        this.selectedRole = this.rolelist[0];
  
        this.selectedRelatedUserAttachmentUpl = this.userlist[0];
      }catch(error) {
        console.log(error);
      }finally{
        this.isRequestPending = false;
        this.loadingButton = null;
        this.loadingRowId = null;
      }
    },

    roleChangedFilterUserList() {
      //isattachmentmaster
      // seçilen role id ile
      // userlistteki role

      var userlistorigin = this.userlist;
      console.log("USER LIST ORIGIN");
      console.log(userlistorigin);
      this.filtereduserlist = userlistorigin.filter(
        (x) => x.roleId == this.selectedRole.id
      );
      console.log("filtereduserlist filtereduserlist filtereduserlist");
      console.log(this.filtereduserlist);
      console.log("roleChangedFilterUserList RUN");

      //this.filtereduserlist = this.userlist.filter(x=>x.roleId == this.selectedRole.id);
    },


    async showAttachmentReleaseModal(
      KFNL,
      value,
      STD,
      JLVT,
      stat,
      flightArchiveStat,
      post
    ) {

      this.isRequestPending = true;
      this.loadingButton = 'ofp';
      this.loadingRowId = value;

      try{
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          value
        );

        JLVT = this.occVersionInfoByKFZ.jlvt;
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;
        if (stat == 1) {
          this.isActiveAttachmentModal = true;
          this.attachmentActiveType = "Operational Flight Plan";
          this.attachmentActiveFKey = KFNL;
          //alert(this.releaseModalUrl +  value  +'/'+ JLVT +'/'+ STD + '/' + flightArchiveStat)
          flightArchiveStat = 0;
          this.attachmentActiveUrl =
            this.releaseModalUrl +
            value +
            "/" +
            JLVT +
            "/" +
            STD +
            "/" +
            flightArchiveStat;
          console.log("");
          console.log(this.attachmentActiveUrl);
        }
      }catch(error) {
        console.log(error);
      }finally{
        this.isRequestPending = false;
        this.loadingButton = null;
        this.loadingRowId = null;
      }


    },

    async showReportModal(
      FKeyForZip,
      FkeyForNetline,
      STD,
      btostat,
      postflightstat
    ) {
      // deprecated olması gerekmektedir.
      if (btostat != 0 || postflightstat != 0) {
        this.isActiveAttachmentModal = true;
        this.attachmentActiveFKey = FkeyForNetline;
        //alert(this.reportModalUrl + FKeyForZip +'/'+ STD +'/'+FkeyForNetline+'/'+postflightstat)
        this.attachmentActiveUrl =
          this.reportModalUrl +
          FKeyForZip +
          "/" +
          STD +
          "/" +
          FkeyForNetline +
          "/" +
          postflightstat;
      }

      console.log("showReportModal RUN");
    },

    async showReportModalNewGen(
      FKeyForZip,
      FkeyForNetline,
      STD,
      leG_NO,
      flightItem,
      post
    ) {
      //console.log(FKeyForZip+FkeyForNetline+STD+leG_NO);

      this.isActiveEFBReportModal = true;
      this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;
      if (this.isActiveEFBReportModal) {
        this.attachmentActiveFKey = FkeyForNetline;
        this.attachmentActiveUrl =
          this.reportModalUrl +
          FKeyForZip +
          "/" +
          STD +
          "/" +
          FkeyForNetline +
          "/" +
          flightItem.flightArchiveStat;
        // let KFZ = "TCCOE_CAI2882_20220816_EDDV_LTAI"
        // let STD = "2022-08-16 00:00:000"
        // let DeviceUID ="A39FF439-9009-4D7A-9038-47CAD058631D"

        await this.GetEFBReportFiles({
          KFZ: FKeyForZip,
          STD: STD,
          ArchiveId: flightItem.flightArchiveStat,
        });
        await this.showEFBReportModal({
          FKeyForZip: FKeyForZip,
          LegNo: leG_NO,
          FlightItem: flightItem,
        });
        console.log("showReportModalNewGen RUN");
      }
    },

    async showWeatherChartModal(KFNL, KFZ, STD, WLVT, stat, flightArchiveStat,post) {
      this.isRequestPending = true;
      this.loadingButton = 'weatherchart';
      this.loadingRowId = KFZ;

      try{
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          KFZ
        );
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        //  var OccVersion  = await ScheduleService.getOccVersionInfoByKFZ(KFZ);
        WLVT = this.occVersionInfoByKFZ.wlvt;
        if (stat == 1) {
          this.attachmentActiveType = "Weather Charts";
          this.isActiveAttachmentModal = true;
          this.attachmentActiveFKey = KFNL;
          console.log(flightArchiveStat);
          flightArchiveStat = 0;
          this.attachmentActiveUrl =
            this.weatherModalUrl +
            KFZ +
            "/" +
            STD +
            "/" +
            WLVT +
            "/" +
            flightArchiveStat;
        }
      }catch(error) {
        console.log(error);
      }finally{
         this.isRequestPending = false;
         this.loadingButton = null;
         this.loadingRowId = null;
      }
    },

    async showNotamModal(KFNL, KFZ, STD, WLVT, stat, flightArchiveStat, post) {
      this.isRequestPending = true;
      this.loadingButton = 'notam';
      this.loadingRowId = KFZ;

      try {
        // Version çekilecek. occVersionInfoByKFZ doldurulup wlvt verilsin.
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          KFZ
        );
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;
        WLVT = this.occVersionInfoByKFZ.wlvt;

        if (stat != 1) {
          return;
        }
        await this.GetWRjson({
          KFZ: KFZ,
          STD: STD,
          WLVT: WLVT,
          ArchiveStat: flightArchiveStat,
        });
        await this.getWeatherNotamRequestData(
          KFZ,
          STD,
          WLVT,
          flightArchiveStat
        );
        this.WRjsonData = this.S_WRjsonData;
        this.isActiveNotamJsonModal = true;
      } catch (error) {
        console.log(error);
        //this.$notify({title: "Error", text:"Error on showNotamModal function "+ e.message, type: "error"});
      }finally{
        this.isRequestPending = false;
        this.loadingButton = null;
        this.loadingRowId = null;
      }

      console.log("showNotamModal RUN");
    },

    async showNotamFIRModal(KFNL, KFZ, STD, WLVT, stat, flightArchiveStat,post) {
      this.isRequestPending = true;
      this.loadingButton = 'notamfir';
      this.loadingRowId = KFZ;

      try {
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          KFZ
        );
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        WLVT = this.occVersionInfoByKFZ.wlvt;

        if (stat != 1) {
          return;
        }
        await this.GetWRjson({
          KFZ: KFZ,
          STD: STD,
          WLVT: WLVT,
          ArchiveStat: flightArchiveStat,
        });
        await this.getWeatherNotamRequestData(
          KFZ,
          STD,
          WLVT,
          flightArchiveStat
        );
        this.WRjsonData = this.S_WRjsonData;
        this.isActiveNotamFIRJsonModal = true;
      } catch (e) {
        console.log(e);
        //this.$notify({title: "Error", text:"Error on showNotamFIRModal function "+ e.message, type: "error"});
      }finally{
       this.isRequestPending = false;
       this.loadingButton = null;
       this.loadingRowId = null;
      }

    },

    async showWeatherTextModal(KFZ, STD, WLVT, stat, ArchiveStat, post) {
      this.isRequestPending = true;
      this.loadingButton = 'weathertext';
      this.loadingRowId = KFZ;

      try {
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          KFZ
        );
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        
        WLVT = this.occVersionInfoByKFZ.wlvt;
        if (stat != 1) {
          return;
        }
        await this.GetWRjson({
          KFZ: KFZ,
          STD: STD,
          WLVT: WLVT,
          ArchiveStat: ArchiveStat,
        });
        await this.getWeatherNotamRequestData(KFZ, STD, WLVT, ArchiveStat);
        this.isActiveWeatherJsonModal = true;
      } catch (error) {
        console.log(error);
        //this.$notify({title: "Error", text:"Error on showWeatherTextModal function "+ e.message, type: "error"});
      }finally{
        this.isRequestPending = false;
        this.loadingButton = null;
        this.loadingRowId = null;
      }

      console.log("showWeatherTextModal RUN");
    },

    // string KFZ, DateTime STD,  int WLVT,  int ArchiveId
    async getWeatherNotamRequestData(KFZ, STD, WLVT, ArchiveStat) {
      try {
        await this.GetWeatherNotamRequestJetPData({
          KFZ: KFZ,
          STD: STD,
          WLVT: WLVT,
          ArchiveStat: ArchiveStat,
        });
      } catch (e) {
        //this.$notify({title: "Error", text:"Error on getWeatherNotamRequestData function "+ e.message, type: "error"});
      }
    },

    async showRaimPredictionModal(
      KFNL,
      KFZ,
      STD,
      WLVT,
      stat,
      flightArchiveStat,
      post
    ) {
      this.isRequestPending = true;
      this.loadingButton = 'raim';
      this.loadingRowId = KFZ;

      try {
        this.occVersionInfoByKFZ = await ScheduleService.getOccVersionInfoByKFZ(
          KFZ
        );
        this.headerFlightText = `${post.carrier}${post.fnO_CORRECTED}${post.suffix || ''}`;

        WLVT = this.occVersionInfoByKFZ.wlvt;

        this.attachmentActiveFKey = KFNL;
        if (stat != 1) {
          return;
        }

        await this.GetWRjson({
          KFZ: KFZ,
          STD: STD,
          WLVT: WLVT,
          ArchiveStat: flightArchiveStat,
        });
        if (this.S_WRjsonData != null) {
          this.isActiveHtmlModal = true;
        }
      } catch (e) {
        console.log(e);   
        //this.$notify({title: "Error", text:"Error on showRaimPredictionModal function"+ e.message, type: "error"});
      }finally{
        this.isRequestPending = false;
        this.loadingButton = null;
        this.loadingRowId = null;
      }
    },

    goToEditFlight(value, leG_NO) {
      this.$router.push({
        name: "EditFlight",
        params: { id: value, SearchDate: this.SearchDate, Leg_No: leG_NO },
      });
    },

    goToCreateFlight() {
      this.$router.push({
        name: "CreateFlight",
        params: { SearchDate: this.SearchDate },
      });
    },

    ForceUpdateNetlineIntegration() {
      // netline force update module service yazılacak .....
    },

    DisplayElementsByClassName(ClassName, DisplayType) {
      // "filepond--file-action-button"
      var elementsp = document.getElementsByClassName(ClassName);

      console.log("elementsp");
      console.log(elementsp);
      for (var p = 0; p < elementsp.length; p++) {
        elementsp[p].style.display = DisplayType; //"none" , "block"
        console.log(elementsp[p]);
        console.log(elementsp[p].style.display);
      }

      console.log("DisplayElementsByClassName RUN");
    },

    DeleteOptions(
      attachmentId,
      KeyForNetline,
      RealName,
      AttachmentTypeId,
      DeleteBy
    ) {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "#C5381A",
        confirmButtonColor: "#1874DA",
        confirmButtonText: "Yes",
      }).then((response) => {
        if (response.value) {
          this.tryDeleteDocument(
            attachmentId,
            KeyForNetline,
            RealName,
            AttachmentTypeId,
            DeleteBy
          );
        } else {
          this.$swal("The document not deleted.");
        }
      });

      console.log("DeleteOptions RUN");
    },

    async tryRevertAttachment(
      attachmentId,
      KeyForNetline,
      RealName,
      AttachmentTypeId,
      DeleteBy
    ) {
      try {
        const revert = await ScheduleService.revertAttachment(
          attachmentId,
          KeyForNetline,
          RealName,
          AttachmentTypeId,
          DeleteBy
        );
        this.message = revert.data;

        if (revert.data == "") {
          //this.$notify({title: "Success", text: this.message, type: "success"})
        } else if (revert.data != "") {
          //this.$notify({title: "Error", text: this.message, type: "error"})
        }

        await this.getDeleteAttachments(this.activeFKey);
        await this.getAttachmentByFlights(this.activeFKey);
      } catch (e) {
        //this.$notify({title: "Error", text:"Error on tryRevertAttachment"+ e.message, type: "error"});
      }

      console.log("tryRevertAttachment RUN");
    },

    async tryDeleteDocument(
      attachmentId,
      KeyForNetline,
      RealName,
      AttachmentTypeId,
      DeleteBy
    ) {
      try {
        if (this.user.isAttachmentMaster != 1) {
          await this.deleteDocumentV2({
            AttachmentId: attachmentId,
            KeyForNetline: KeyForNetline,
            RealName: RealName,
            AttachmentTypeId: AttachmentTypeId,
            DeleteBy: DeleteBy,
          });

          if (this.returnMessage == "") {
            //this.$notify({title: "Success", text: "Attachment has been moved successfully", type: "success"});
          } else if (this.returnMessage != "") {
            //this.$notify({title: "Error", text: this.returnMessage , type: "error"});
          }
        } else {
          if (
            this.selectedRelatedUserAttachmentUpl == null ||
            this.selectedRelatedUserAttachmentUpl != ""
          ) {
            //this.$notify({title: "Error", text: "User couldn't selected. Select a user, for delete file" , type: "error"});
            return;
          }
          if (
            this.this.AttachmentMasterModel.CreateDt == null ||
            this.this.AttachmentMasterModel.CreateDt != "" ||
            this.this.AttachmentMasterModel.ModifyDt == null ||
            this.this.AttachmentMasterModel.ModifyDt != ""
          ) {
            //this.$notify({title: "Error", text: "User couldn't selected. Select a user, for delete file" , type: "error"});
            return;
          }

          ScheduleService.deleteDocument_SpecialFunc(
            attachmentId,
            KeyForNetline,
            RealName,
            AttachmentTypeId,
            this.selectedRelatedUserAttachmentUpl.fullName,
            this.AttachmentMasterModel.CreateDt,
            this.AttachmentMasterModel.ModifyDt
          );
        }

        await this.$store.dispatch("schedule/getAttachmentByFlights");
        this.getDeleteAttachments(this.activeFKey);
      } catch (e) {
        //this.$notify({title: "Error", text:"Error on tryDeleteDocument function"+ e.message, type: "error"});
      }

      console.log("tryDeleteDocument RUN");
    },

    trycloseUploadModal() {
      this.$refs.pond.removeFiles();
      // this.$refs.pond.removeFile();
      this.message = null;
      this.ManipulateAttachmentCNT();
      //this.TrygetScheduleFlights();
      this.closeUploadModal();
    },

    trygetAttachmentByFlights() {
      // this.$refs.pond.removeFile();
      this.getAttachmentByFlights();
    },

    dtConverterToMinHour(dt) {
      return moment(dt).format("YYYY-MM-DD HH:mm");
    },

    CalculateFlightCounts() {
      var TotalFlights = 0;
      var Completed = 0;
      var Overdue = 0;
      var Inprogress = 0;

      var i;

      var checkRelatedAircrafts = this.showRelatedAircrafts;

      for (i = 0; i < this.flightList.length; i++) {
        // true gelirse tek if çalışcak , false gelirse hem true hem false u alcak
        if (
          this.flightList[i].iS_DELETED == false &&
          (checkRelatedAircrafts == true
            ? this.flightList[i].iS_AIRCRAFT_USED == checkRelatedAircrafts
            : this.flightList[i].iS_AIRCRAFT_USED == true ||
              this.flightList[i].iS_AIRCRAFT_USED == false)
        ) {
          TotalFlights++;

          if (this.flightList[i].progress == 2) {
            Inprogress++;
          } else if (this.flightList[i].progress == 1) {
            Completed++;
          } else if (this.flightList[i].progress == 3) {
            Overdue++;
          }
        }
      }

      this.FlightCounts.TotalFlights = TotalFlights;
      this.FlightCounts.Completed = Completed;
      this.FlightCounts.InProgress = Inprogress;
      this.FlightCounts.Overdue = Overdue;
    },

    filterFlights() {
      this.isFiltering = true;

      setTimeout(() => {
        const searchTerm = (this.searchText || "").trim().toLowerCase();
        const originalList = Array.isArray(this.flightList)
          ? this.flightList
          : [];

        if (!searchTerm) {
          this.filteredFlights = null;
          this.isFiltering = false;
          return;
        }

        const filtered = originalList.filter((flight) => {
          const searchableFields = [
            flight.carrier,
            flight.adep,
            flight.aarr,
            flight.acreg,
            flight.fno,
            flight.carrierfno,
            flight.cP1,
            flight.cP2,
            flight.cP3,
          ];

          return searchableFields.some((field) =>
            field?.toLowerCase().includes(searchTerm)
          );
        });

        this.filteredFlights = [...filtered].sort(
          (a, b) => a.sortOrder - b.sortOrder
        );

        this.isFiltering = false;
      }, 200);
    },

    onSearchInput() {
      this.debouncedFilter();
    },
  },

  watch: {

    flightList(newVal) {
      if (!newVal || !newVal.length) return;

      const searchTerm = (this.searchText || "").trim();
      if (searchTerm) {
        this.debouncedFilter();
      } else {
        this.filteredFlights = null;
      }
    },
  },

  mounted() {
    this.startCheckChangesInterval();
    this.$el.addEventListener('click', this.blockIfPending, true);
    this.$el.addEventListener('change', this.blockIfPending, true);
    this.$el.addEventListener('input', this.blockIfPending, true);

    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) {
        //ESC
        this.$store.dispatch("schedule/closeUploadModal");
      }
    }),
      document.body.addEventListener("keyup", (e) => {
        if (e.keyCode === 115) {
          //F5
        }
      });
  },

  beforeRouteLeave(to, from, next) {
    this.checkChanges = false;
    next();
  },

  beforeDestroy() {
    this.$el.removeEventListener('click', this.blockIfPending, true);
    this.$el.removeEventListener('change', this.blockIfPending, true);
    this.$el.removeEventListener('input', this.blockIfPending, true);

    this.stopCheckChangesInterval();
  },

  created() {
    console.log(this.$route.params.date);
    localStorage.selectedDate = this.$route.params.date;

    if (localStorage.selectedDate) {
      this.$store.dispatch(
        "schedule/setSearchValueData",
        localStorage.selectedDate
      );
    }

    this.datepickerDate = localStorage.selectedDate;

    // for datepicker component's prop highlighted
    var t = Date.now();
    this.highlighted = { dates: [new Date(t)] };

    this.TrygetScheduleFlights();
    this.getNotamImportantWordList();
    this.checkChanges = true;

    this.calcAddday = new Date();
    setInterval(() => {
      try {
        if (this.DbDTUtc == null) {
          var utcDate = new Date();
          const nextDay = new Date(utcDate);
          nextDay.setDate(utcDate.getDate() + 1);
          this.calcAddday = nextDay;
          //utcDate = utcDate.setUTCHours(utcDate.getHours());
          // utcDate = utcDate.setUTCHours(utcDate.getHours()).getDate()+1;
          //this.calcAddday = moment(utcDate).format('YYYY-MM-DD HH:mm')
          //this.calcAddday.setDate(utcDate.getDate() + 2);
          // this.calcAddday = utcDate
          //alert(this.calcAddday)
          //calcAddday.setDate(calcAddday.getDate() + 1);
          //this.calcAddday = moment(this.calcAddday.setDate(this.calcAddday.getDate()+1)).format('YYYY-MM-DD HH:mm');
          //this.calcAddday = moment(this.calcAddday.setDate(this.calcAddday.getDate())).format('YYYY-MM-DD HH:mm');
          //this.calcAddday = moment(this.calcAddday).add(1, 'day').format('YYYY-MM-DD HH:mm');
        } else {
          this.currentDateWithFormat = moment(this.DbDTUtc).format(
            "YYYY-MM-DD HH:mm"
          );
          const base = new Date(this.DbDTUtc);
          const nextDay = new Date(base);
          nextDay.setDate(base.getDate() + 1);
          this.calcAddday = nextDay;
          //this.calcAddday.setDate(this.DbDTUtc.getDate() + 2);
          //this.calcAddday = this.DbDTUtc
          //    alert("Else :::: "+this.calcAddday)
          //this.calcAddday =  this.currentDateWithFormat;
          //this.calcAddday = moment(this.calcAddday.setDate(this.calcAddday.getDate()+1)).format('YYYY-MM-DD HH:mm');
          //this.calcAddday = moment(this.calcAddday.setDate(this.calcAddday.getDate())).format('YYYY-MM-DD HH:mm');
          //this.calcAddday = moment(this.calcAddday).add(1, 'day').format('YYYY-MM-DD HH:mm');
          //alert(this.calcAddday+ " 2calcAddday else");
        }

        //this.calcAddday.setDate(this.calcAddday.getDate() + 2);
        //
        // this.calcAddday = moment(this.calcAddday.setDate(this.calcAddday.getDate()+1)).format('YYYY-MM-DD HH:mm');
        // alert(calcAddday);
        this.disabledDays = { from: this.calcAddday };
        this.CurrentTime = moment(this.DbDTUtc).format("YYYY-MM-DD HH:mm");
      } catch (e) {
        console.log("Error on setInterval e: " + e.message);
      }
    }, 2000);

    console.clear();
    this.debouncedFilter = _.debounce(() => {
      this.filterFlights();
    }, 600);
  },

  // asyncComputed: {
  //     async myResolvedValue() {
  //         return await api.get(`/users/${this.value.username}/message/`, {'headers': { 'Authorization': 'JWT ...' }})
  //             .then(response => response.data)
  //     }
  // },

  computed: {
    ...mapState("schedule", [
      "flightList",
      "changeFlightListId",
      "DailyFlightCount",
      "attachmentsFlight",
      "openShowFileCount",
      "idOfPdf",
      "isActiveFileUpload",
      "isActiveShowFile",
      "activePdfUrl",
      "files",
      "returnMessage",
      "flightMessage",
      "deleteAttachments",
      "activeFKey",
      "activeFlightData",
      "releaseModalUrl",
      "notamModalUrl",
      "meteoModalUrl",
      "weatherModalUrl",
      "reportModalUrl",
      "jsonData",
      "S_WRjsonData",
      "S_WNReqJetP_Data",
      "activeFkeyForZip",
      "activeStd",
      "activeArchiveId",
      "timeSpan",
      "DbUtcDT",
      "FlightofattachmentTypesState",
      "isActiveFlightNote",
      "ActiveFlightNotes",
      "FlightNoteList",
      "activeLegNo",
      "userlist",
      "rolelist",
    ]),

    ...mapState("auth", ["user"]),

    displayedFlights() {
      const baseList = [...this.flightList]
        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));

      if (!this.searchText || this.searchText.trim() === "") {
        return baseList;
      }


      return this.filteredFlights || baseList;
    },



    displayedFlightsCount() {
      return this.displayedFlights.length;
    },

    ChangeOfFlightCounts: {
      get() {
        this.CalculateFlightCounts();
        return this.FlightCounts;
      },
    },

    // eslint-disable-next-line vue/return-in-computed-property
    excelArray: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.excelBody = this.excelFlightList.map((item) => ({
        aC_OWNER: item.aC_OWNER,
        aL_LVC: item.aL_LVC,
        aL_SignedBy: item.aL_SignedBy,
        aarr: item.aarr,
        acreg: item.acreg,
        adep: item.adep,
        ata: item.ata,
        atd: item.atd,
        attachmentCount: item.attachmentCount,
        btO_LVC: item.btO_LVC,
        btO_SignedBy: item.btO_SignedBy,
        cP1: item.cP1,
        cP2: item.cP2,
        cP3: item.cP3,
        cabinList: item.cabinList,
        callsign: item.callsign,
        carrier: item.carrier,
        carrierfno: item.carrierfno,
        devicE_UUID1: item.devicE_UUID1,
        devicE_UUID2: item.devicE_UUID2,
        devicE_UUID3: item.devicE_UUID3,
        diS_TYPE: item.diS_TYPE,
        diV_ARR: item.diV_ARR,
        errorCOunt: item.errorCOunt,
        fKeyForZip: item.fKeyForZip,
        flightArchiveStat: item.flightArchiveStat,
        flightRelease: item.flightRelease,
        flightReportStat: item.flightReportStat,
        fnO_CORRECTED: item.fnO_CORRECTED,
        fno: item.fno,
        generaL_STAT: item.generaL_STAT,
        iS_AIRCRAFT_USED: item.iS_AIRCRAFT_USED,
        iS_DELETED: item.iS_DELETED,
        jlvt: item.jlvt,
        lasT_IPADDEVICE_UID: item.lasT_IPADDEVICE_UID,
        lasT_LVC: item.lasT_LVC,
        lastPlanIdSucceed: item.lastPlanIdSucceed,
        leG_NO: item.leG_NO,
        notE_CNT: item.notE_CNT,
        notamWeb: item.notamWeb,
        progress: item.progress,
        raimPrediction: item.raimPrediction,
        sarr: item.sarr,
        sdep: item.sdep,
        sortOrder: item.sortOrder,
        sta: item.sta,
        staT_MIN1: item.staT_MIN1,
        staT_MIN2: item.staT_MIN2,
        staT_MIN3: item.staT_MIN3,
        std: item.std,
        suffix: item.suffix,
        tarih: item.tarih,
        tlC1: item.tlC1,
        tlC2: item.tlC2,
        tlC3: item.tlC3,
        warningCOunt: item.warningCOunt,
        weather: item.weather,
        weatherWeb: item.weatherWeb,
        wlvt: item.wlvt,
      }));

      return this.excelBody;
    },

    CalculatedNext2Days: {
      get() {
        return this.dbDT;
      },
    },

    CurrentTimeFinishAdded: {
      get() {
        return moment(this.currentDateWithFormat, "YYYY-MM-DD HH:mm")
          .add(180, "m")
          .format("YYYY-MM-DD HH:mm");
      },
    },

    CurrentTimeStartsubtracted: {
      get() {
        return moment(this.currentDateWithFormat, "YYYY-MM-DD HH:mm")
          .add(-60, "m")
          .format("YYYY-MM-DD HH:mm");
      },
    },

    DbDTUtc: function () {
      return this.DbUtcDT;
    },

    SearchDate: {
      get() {
        return this.$store.state.schedule.SearchDate;
      },
      set(value) {
        localStorage.selectedDate = value;
        this.$store.dispatch("schedule/setSearchValueData", value);
      },
    },

    idOfPdf: {
      get() {
        return this.$store.state.schedule.idOfPdf;
      },
      set(value) {
        this.$store.dispatch("schedule/updateIdOfPdf", value);
      },
      files: {
        get() {
          return this.$store.state.schedule.files;
        },
        set(value) {
          this.$store.dispatch("schedule/setUploadFiles", value);
        },
      },
    },
  },
};
</script>
<style lang="scss">
input.input-class {
  height: 40px;
  border-radius: 5px;
  border-bottom-right-radius: unset;
  border-top-right-radius: unset;
  border-color: #dadada;
  font-size: medium;
}

.schedule-table td,
.schedule-table th {
  white-space: nowrap;
  vertical-align: middle;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #c9c9c9;
  border-radius: 10px;
  transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #9e9ea2;
}


</style>

<style lang="scss" scoped>
.pilotStatus {
  font-size: 17px;
  padding: 4px;
}

.hideDeletedFlight {
  display: none;
}

/* iSDELETED = 1 stroke line trough row */
table {
  border-collapse: collapse;
}

td {
  position: relative;
  padding: 5px 10px;
}

tr.strikeout td:before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 1px solid #111;
  width: 100%;
}
/* iSDELETED = 1 stroke line trough row */

.alert {
  padding: 20px;
  background-color: #f44336; /* Red */
  color: white;
  margin-bottom: 15px;
}

/* The close button */
.closebtn {
  margin-left: 15px;
  color: blue;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

/* When moving the mouse over the close button */
.closebtn:hover {
  color: black;
}

.NotifyTooltip .NotifyTooltipText {
  visibility: hidden;
  min-width: 280px;
  max-width: 420px;
  background-color: #455f83;
  color: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-right: 23px;
  margin-top: 23px;
  font-size: 15px;
  font-family: Consolas;
  position: absolute;
  z-index: 9999;
}

.NotifyTooltip:hover .NotifyTooltipText {
  visibility: visible;
  opacity: 0.85;
}

.NotifyTooltipText:hover {
  display: none;
  visibility: hidden;
}


.notification {
  margin-bottom: 5px;
}


font-awesome-icon {
  cursor: pointer;
}

.schedule-flight-count-box {
  margin-bottom: 10px;
}

tbody tr:nth-last-child(-n + 5) .NotifyTooltipText {
  top: auto !important;
  bottom: 120% !important;
}

.schedule-table-main {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  overflow-x :auto;
  width: 100%;


   &::-webkit-scrollbar {
    height: 8px;
  }

}

// #6a85a7
.schedule-table-main thead th {
  color: #fff;
  background-color: #455f83;
  font-size: 18px;
  padding: 6px 12px;
  z-index: 2;
  text-align: center;
}

.schedule-table td {
  border: 0px;
  padding: 6px 12px;
  text-align: center;
}

.box-info {
  margin-top: -20px;
}

.sliderButton {
  border: 1px solid;
  height: 28px;
  border-radius: 8px;
  width: 76px;
}

.offButton {
  margin-left: 30px;
  padding: 14px;
}

.onButton {
  padding: 14px;
}

.button-fade-enter-active,
.button-fade-leave-active {
  transition: opacity 0.5s ease;
}

.button-fade-enter,
.button-fade-leave-to {
  opacity: 0;
}

.div-border {
  display: flex;
  padding: 10px;
  border: 1px solid #e4e4e4;
  border-left: 5px solid;
  cursor: pointer;
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}



.table-row-transition {
  animation-duration: 15s;
  animation-name: table-row;
  -webkit-animation-name: table-row;
}

.model-row-transition {
  animation-duration: 10s;
  animation-name: table-row;
  -webkit-animation-name: table-row;
}

@-webkit-keyframes table-row {
  0% {
    opacity: 1;
    background-color: yellow;
  }
  10% {
    opacity: 0.1;
    background-color: yellow;
  }
  20% {
    opacity: 1;
    background-color: yellow;
  }
  30% {
    opacity: 0.1;
    background-color: yellow;
  }
  40% {
    opacity: 1;
    background-color: yellow;
  }
  50% {
    opacity: 0.1;
    background-color: yellow;
  }
  60% {
    opacity: 1;
    background-color: yellow;
  }
  70% {
    opacity: 0.1;
    background-color: yellow;
  }
  80% {
    opacity: 1;
    background-color: yellow;
  }
  90% {
    opacity: 0.1;
    background-color: yellow;
  }
  100% {
    opacity: 1;
    background-color: yellow;
  }
}

@keyframes table-row {
  0% {
    opacity: 1;
    background-color: yellow;
  }
  10% {
    opacity: 0.1;
    background-color: yellow;
  }
  20% {
    opacity: 1;
    background-color: yellow;
  }
  30% {
    opacity: 0.1;
    background-color: yellow;
  }
  40% {
    opacity: 1;
    background-color: yellow;
  }
  50% {
    opacity: 0.1;
    background-color: yellow;
  }
  60% {
    opacity: 1;
    background-color: yellow;
  }
  70% {
    opacity: 0.1;
    background-color: yellow;
  }
  80% {
    opacity: 1;
    background-color: yellow;
  }
  90% {
    opacity: 0.1;
    background-color: yellow;
  }
  100% {
    opacity: 1;
    background-color: yellow;
  }
}

.datepicker:hover {
  padding-right: 10px;
  box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}

tbody > tr:hover {
  color: #004e89;
  border-bottom: 0.1px solid #f5f5f5;
  border-top: 0.1px solid #f5f5f5;
  border-radius: 2px;
  /*background-color: #363636;*/
  /*border:black;*/
  /*border-width: 1px;*/
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.modalButton {
  float: right;
}

.modal-card-foot {
  float: right;
}

iframe {
  position: absolute;
  height: 100%;
  width: 100%;
  border: none;
}

.showModalIconLeft {
  padding-right: 35px;
}

.closeButton {
  margin-left: 93%;
}

.ColumnEmbed {
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modal-content {
  border-radius: 16px;
  width: 90%;
  max-width: 1500px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
}

.preview-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.card-columns {
  height: 100%;
}


.attachment-file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.attachment-file-icon{
  width: 100%;
  display: flex;
  gap: 10px;
  font-weight: 500;
  overflow: hidden;
}

.attachment-file:hover {
  background: #f2f3f5;
}


.attachment-file.selected-attachment {
  background: #f2f3f5;
}

.file-realName{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1; 
}

.file-sidebar {
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.device-section {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}


.attachment-item-name {
  font-size: 16px;
  width: 100%;
}

.file-item-top{
  display: flex;
  justify-content: space-between;
}

.file-item-bottom{
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: flex-end;
}

.preview-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
}


.issue-details--meta > li:not(:last-child) {
  margin-bottom: 15px;
}

.issue-details--meta-title {
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #9e9e9e;
  font-weight: 700;
}

.issue-details--meta-desc {
  font-size: 14px;
  font-weight: 300;
}

.flex-form {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input-hover:hover {
  padding-right: unset !important;
  transform: unset !important;
}

.column {
  padding: 10px 0 0 0 !important;
  //padding-top: 6px!important;
}

.box-info-search.input {
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 300px;

  &::placeholder {
    color: #999;
  }
}

.icon.is-left {
  color: #aaa;
}

.attachment-cell {
  text-align: center;

  .attachment-button {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    border-radius: 8px;
    padding: 2px 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    // min-width: 45px;
  }
}

.flight-number,
.call-sign {
  font-family: monospace;
}

// .schedule-flight-count-box {
//   margin-bottom: 20px;
// }

.schedule-flight-count-box .count-text {
  flex: 1;
  color: #666666;
}

.box-info-search.input:disabled {
  background-color: #f5f5f5;
  opacity: 0.6;
}

.control.has-icons-right .icon.is-right {
  pointer-events: none;
  color: #455f83;
}

.notify-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 12px;
}

.notes-container {
  position: relative;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

// .notes-container .no-note {
//   color: #555;
// }

.notes-container .has-note {
  color: #10B981;
}

.note-count {
  position: absolute;
  top: 1px;
  right: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #10B981;
  color: #fff;
  border: 2px solid #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
}

.notify-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.notify-btn .fa-bell {
  font-size: 18px;
  color: #555;
}

.icon-color{
  color: #888;
}

.table-wrapper-scroll {
  overflow-x: auto;
  position: relative;
  max-width: 100%;
}

.sticky-column {
  position: sticky;
  left: 0;
  background: white;
  z-index: 20;
  max-width: 200px;
}

.sticky-column::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;   
  width: 1px;
  height: 100%;
  background: #dbdbdb;
  z-index: 30;
  transform: translateX(-1px);
}

.sticky-column::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px; 
  width: 1px;
  height: 100%;
  background: #dbdbdb;
  z-index: 30;
}

tbody tr:hover .sticky-column {
  background-color: #fafafa;
  cursor: pointer;
}

.document-name {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  min-width: 0; 
  width: 100%;
}

.document-name-text {
  flex: 1;           
  min-width: 0;         
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-upload-section {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: #fefefe;
  border: 2px dashed #cbd5e0;
  padding: 40px 20px;
  transition: all 0.3s ease;
}

.file-upload-section:hover {
  border: 2px dashed #bdbdbd;
}
</style>
